/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import XDownloader from "./Classes/XDownloader";
import CountUpNumbers from './Classes/CountUpNumbers';
import Video from './Classes/Video';
import SliderHandler from './Classes/SliderHandler';
import Highcharts from './lib/highcharts';
import Accordion from './Classes/Accordion';
// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';
import HashHandler from './Classes/HashHandler';
import ToTop from './Classes/ToTop';
import Header from './Classes/Header';
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var downloaderInstance = null;

var accordionInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var videoInstance = null;
var toTopInstance = null;
var headerIntsance = null;

var countUpInstance = null;

var frontpageSliderInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  new ResponsiveTablesLight({
    tableComponentSelector: '.ns-table-wrap',
    tableContainerSelector: '.ns-table-container',
    tableSelector: '.ns-table-wrap table'
  });

  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  Highcharts.setOptions({
    lang: {
      decimalPoint: '.', // default: '.'
      numericSymbols: null, // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
      thousandsSep: '’', // default: '\u0020'
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    }
  });

  downloaderInstance = new XDownloader({
    downloadText: "Download Excel", //Can be empty if you want to use an icon instead
    backgroundColor: "6ab04c", //Colored Cells Background
    backgroundClass: 'ns-backgroundcolor-gf_3a-green', //Class of colored cells
    borderColor: '95afc0', //Color of border
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    headClass: 'head', //Class you want your columns based on. Will be bold in Excel
    boldClass: 'title', //Class for Bold text in Excel
    borderClass: 'ns-borderbottom-line_dots'
  });

  accordionInstance = new Accordion( {
    accordions: '.ns-accordion__head',
    pxCorrection: Helper.isDesktop()? -128 : -70
  });


  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  videoInstance = new Video();
    new HashHandler();

  countUpInstance = new CountUpNumbers({
    numbersSelector: '.ns-keyfigure__number',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['en-US'],
    decimalArray: ['.'],
    thousandSepArray: ['’'],
  });

  frontpageSliderInstance = new SliderHandler({
    sliderType: 'header',
    outerWrapperSelector: '.slider--lead-tiles'
  });


  toTopInstance = new ToTop({
    minScrollVisible: 200
  });

  headerIntsance = new Header({
    headerSelector: '.header',
    burgerSelector: '.js-burger-toggle',
    navigationSelector: '.header-navigation',
    navItemSelector: '.menu__item--has-children .menu__link--level-0',
    initialActiveItemSelector: '.menu__item--level-0.menu__item--ancestor-active',
  });
});
